import { Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from '@store/store.ts'
import { receiveEndpoints } from '@actions/endpoint_actions.js'
import { hydrateCurrentUser, hydrateGroupsFromDOMNode } from '@utils/hydrator.js'
import SuspenseFallback from '@components/SuspenseFallback.tsx'

const PeopleContainer = lazy(() =>
  import('@features/people/index.js').then(module => ({ default: module.PeopleContainer }))
)

window.Timetoast.people = {
  index: {
    init: function (options, reactTarget) {
      store.dispatch(receiveEndpoints(options.endpoints))
      hydrateCurrentUser()
      hydrateGroupsFromDOMNode(options.user.groupsDOMId)
      const root = createRoot(reactTarget)
      root.render(
        <Provider store={store}>
          <Suspense fallback={<SuspenseFallback withPadding={true} />}>
            <PeopleContainer accountId={options.accountId} signupCode={options.signupCode} options={options} />
          </Suspense>
        </Provider>
      )
    },
  },
}
